import type { CtaRequiredPageId } from '../page-registry';
import type { CTAContent } from '../schema';

export const ctas = {
  home: {
    id: 'cta.home',
    legacyId: '6hMIfl4Gm573POuCFMnFga',
    page: 'home',
    title: 'Heritage Woven Into Every Thread',
    subtitle: 'Explore our timeless collections or get in touch to begin your journey with us.',
    ctaText: 'Let us create something timeless for you.',
    ctaUrl: '/contact',
  },
  about: {
    id: 'cta.about',
    legacyId: '6X89FRlptH3pctIesA6jnv',
    page: 'about',
    title: 'A Legacy Woven for the Future',
    subtitle: 'Every saree we create is a celebration of heritage and the promise of tomorrow.',
    ctaText: 'Discover the tradition. Explore our collections.',
    ctaUrl: '/collections',
  },
  collections: {
    id: 'cta.collections',
    legacyId: '1mHuoBC5XOCi0Hx6SVToGv',
    page: 'collections',
    title: 'Find the Perfect Piece, Every Time',
    subtitle: 'Behind every saree is a story waiting to be told. Discover the elegance that is made for you.',
    ctaText: 'Discover Wedding Gifting',
    ctaUrl: '/wedding-gifting',
  },
  contact: {
    id: 'cta.contact',
    legacyId: '3LviNQDHVpkgtbAtYUDoiU',
    page: 'contact',
    title: "Let's Create Something Beautiful Together",
    subtitle: "Every conversation sparks a new story. Reach out to us and let's weave your next unforgettable memory.",
    ctaText: 'Start Your Journey with Us',
    ctaUrl: '/wedding-gifting',
  },
  journey: {
    id: 'cta.journey',
    legacyId: '3tx4xo5Rk9OhibhFsnjuG8',
    page: 'journey',
    title: 'Join Our Journey',
    subtitle: 'Ready to connect with our legacy? Contact us today to learn more or begin your journey with us.',
    ctaText: 'Be a part of our story today.',
    ctaUrl: '/contact',
  },
  'wedding-gifting': {
    id: 'cta.wedding-gifting',
    legacyId: '7C1ARN9sCJoYeSqWaKPT8',
    page: 'wedding-gifting',
    title: 'Celebrate Moments, Cherish Forever',
    subtitle: 'Turn every celebration into a legacy. Explore our collections to make memories that last a lifetime.',
    ctaText: 'Explore Our Collections',
    ctaUrl: '/collections',
  },
} satisfies Record<CtaRequiredPageId, CTAContent>;

export const defaultGlobalCta = {
  id: 'cta.default-global',
  title: 'Heritage Woven Into Every Thread',
  subtitle: 'Explore our timeless collections or get in touch to begin your journey with us.',
  ctaText: 'Book Consultation',
  ctaUrl: '/contact',
} satisfies CTAContent;
